export function resetLabelsStyles(labels: HTMLLabelElement[]) {
  labels.forEach((label) => {
    if (!label.style.height) {
      return;
    }

    label.style.height = "";
    label.style.alignItems = "center";
  });
}
